module.exports = __webpack_public_path__ + "img/social-media.109639e7.svg";